import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import RSVPCard from "./RSVPCard";
import { getinvitation_templates_by_category } from "../../../Apiservices/Auth/servers/fetchinvitationtemplates";
import { fetchRSVPDetails, submitRSVPResponse } from "../../../services/RSVPServices";
import { Toast } from "primereact/toast";
import "./RSVPInvitationPage_pooja.css";

export const RSVPInvitationPage_pooja = ({ EventDataForInvitation, imageUrl_as_prop }) => {
  const { sharedToken } = useParams();
  const [eventDetails, setEventDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submittedResponse, setSubmittedResponse] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const toast = useRef(null);
  const showSuccess = (detail) => toast.current?.show({ severity: "success", summary: "Response Submitted", detail, life: 3000 });
  const showError = (detail) => toast.current?.show({ severity: "error", summary: "Submission Failed", detail, life: 3000 });

  useEffect(() => {
    let active = true;
    let blobUrl;
    setLoading(true);
    setError(null);
    setEventDetails(null);
    setSubmittedResponse(null);
    setImageUrl(null);
    const load = async () => {
      // Embedded previews use supplied data and images without fetching.
      if (EventDataForInvitation) {
        setEventDetails(EventDataForInvitation);
        setImageUrl(imageUrl_as_prop || null);
        setLoading(false);
        return;
      }
      try {
        const saved = JSON.parse(localStorage.getItem(`rsvp_${sharedToken}`));
        if (saved && typeof saved === "object" && !Array.isArray(saved)) {
          setSubmittedResponse(saved);
          setLoading(false);
          return;
        }
      } catch {
        // A corrupt or unavailable cache must not block loading.
      }
      try {
        const data = await fetchRSVPDetails(sharedToken);
        if (!active) return;
        if (data?.message === "Event not found or invalid token") {
          setError("Sorry, no active event found");
          return;
        }
        if (!data || typeof data !== "object" || Array.isArray(data) || !Object.keys(data).length) return;
        setEventDetails(data);
        if (imageUrl_as_prop) {
          setImageUrl(imageUrl_as_prop);
        } else if (data.EventMasterDetails?.eventName && data.EventMasterDetails?.eventCategoryName && data.imagePath) {
          const category = encodeURIComponent(data.EventMasterDetails.eventCategoryName);
          const title = encodeURIComponent(data.EventMasterDetails.eventName.replace(/\s+/g, ""));
          const screenType = window.innerWidth > 800 ? "web" : "mobile";
          const imagePath = `/templates-bg/${category}/${title}/${screenType}/${data.imagePath}`;
          // Template errors leave the invitation usable, as before.
          try {
            const blob = await getinvitation_templates_by_category(imagePath);
            if (active && blob) {
              blobUrl = URL.createObjectURL(blob);
              setImageUrl(blobUrl);
            }
          } catch { /* The selected template is optional. */ }
        }
      } catch {
        if (active) setError("Sorry, no active event found");
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => { active = false; if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [sharedToken, EventDataForInvitation, imageUrl_as_prop]);

  const handleSubmit = async (values, { setSubmitting }) => {
    const isComing = values.attendance === "yes";
    const rsvpPayload = {
      name: values.name,
      phoneNumber: values.mobile,
      sharedToken: sharedToken,
      isComing: isComing,
      remind: isComing && (values.remind === "yes" || values.remind === true),
      extraMembers: isComing ? Number(values.members) : 0,
      remarks: values.suggestion,
    };

    try {
      const response = await submitRSVPResponse(rsvpPayload);
      if (response.status === 200 || response.status === 201) {
        const rsvpData = {
          ...response.data.rsvp,
          submitted: true,
          statusCode: response.status,
        };
        localStorage.setItem(`rsvp_${sharedToken}`, JSON.stringify(rsvpData));
        setSubmittedResponse(rsvpData);
        showSuccess(`Thank you for your response${rsvpData.name ? `, ${rsvpData.name}` : ""}!`);
      } else if (response.status === 409) {
        const conflictResponse = {
          submitted: true,
          statusCode: response.status,
        };
        localStorage.setItem(
          `rsvp_${sharedToken}`,
          JSON.stringify(conflictResponse)
        );
        setSubmittedResponse(conflictResponse);
        showError("Response already submitted .");
      }
    } catch (error) {
      console.error(error);
      showError("Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };
  let content;
  if (loading) {
    content = <div role="status">Loading...</div>;
  } else if (submittedResponse) {
    content = <div className="rsvp-status"><div className="thank-you-card" role="status"><h2>Thank you for your response{submittedResponse.name ? `, ${submittedResponse.name}!` : ""}</h2></div></div>;
  } else if (error || !eventDetails) {
    content = <div className="rsvp-status"><div className="thank-you-card" role="alert"><h2>{error || "No event details available"}</h2></div></div>;
  } else {
    content = (
      <div className="rsvp-wrapper">
        {imageUrl && <img src={imageUrl} alt="" className="rsvp-image" />}
        <div className="rsvp-content">
          <RSVPCard key={sharedToken || "preview"} {...eventDetails} onSubmitForm={handleSubmit} />
        </div>
      </div>
    );
  }
  return <div className={`rsvp-invitation-container rsvp-public-page${EventDataForInvitation ? " rsvp-preview" : ""}`}><Toast ref={toast} />{content}</div>;
};